// get dependencies verison from package.json
export function getVersion(name) {
  const p = require('../../package')
  return p.dependencies[name]
}



// WEBPACK FOOTER //
// ./src/utils/index.js